type SymbolDatas = {
  name: string;
  basic: string;
  intro: string;
  coingeckoLink: string;
  cmcLink: string;
};

export const symbols: Record<string, SymbolDatas> = {
  BTC: {
    name: 'Bitcoin',
    basic: 'symbol_detail.BTC.basic',
    intro: 'symbol_detail.BTC.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/bitcoin',
    cmcLink: 'https://coinmarketcap.com/currencies/bitcoin/',
  },
  USDT: {
    name: 'Tether',
    basic: 'symbol_detail.USDT.basic',
    intro: 'symbol_detail.USDT.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/tether',
    cmcLink: 'https://coinmarketcap.com/currencies/tether',
  },
  ETH: {
    name: 'Ethereum',
    basic: 'symbol_detail.ETH.basic',
    intro: 'symbol_detail.ETH.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/ethereum',
    cmcLink: 'https://coinmarketcap.com/currencies/ethereum',
  },
  LTC: {
    name: 'Litecoin',
    basic: 'symbol_detail.LTC.basic',
    intro: 'symbol_detail.LTC.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/litecoin',
    cmcLink: 'https://coinmarketcap.com/currencies/litecoin',
  },
  XRP: {
    name: 'Ripple',
    basic: 'symbol_detail.XRP.basic',
    intro: 'symbol_detail.XRP.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/xrp',
    cmcLink: 'https://coinmarketcap.com/currencies/xrp',
  },
  ADA: {
    name: 'Cardano',
    basic: 'symbol_detail.ADA.basic',
    intro: 'symbol_detail.ADA.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/cardano',
    cmcLink: 'https://coinmarketcap.com/currencies/cardano',
  },
  OMG: {
    name: 'OmiseGO',
    basic: 'symbol_detail.OMG.basic',
    intro: 'symbol_detail.OMG.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/omg-network',
    cmcLink: 'https://coinmarketcap.com/currencies/omg-network',
  },
  MKR: {
    name: 'MakerDAO',
    basic: 'symbol_detail.MKR.basic',
    intro: 'symbol_detail.MKR.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/maker',
    cmcLink: 'https://coinmarketcap.com/currencies/maker',
  },
  UNI: {
    name: 'Uniswap',
    basic: 'symbol_detail.UNI.basic',
    intro: 'symbol_detail.UNI.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/uniswap',
    cmcLink: 'https://coinmarketcap.com/currencies/uniswap',
  },
  SOL: {
    name: 'Solana',
    basic: 'symbol_detail.SOL.basic',
    intro: 'symbol_detail.SOL.intro',
    coingeckoLink: 'https://www.coingecko.com/coins/solana',
    cmcLink: 'https://coinmarketcap.com/currencies/solana',
  },
  // MATIC: {
  //   name: 'Polygon',
  //   basic: 'symbol_detail.MATIC.basic',
  //   intro: 'symbol_detail.MATIC.intro',
  //   coingeckoLink: 'https://www.coingecko.com/coins/polygon',
  //   cmcLink: 'https://coinmarketcap.com/currencies/polygon',
  // },
  POL: {
    name: 'Polygon',
    basic: 'symbol_detail.POL.basic',
    intro: 'symbol_detail.POL.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/pol-ex-matic',
    cmcLink: 'https://coinmarketcap.com/currencies/polygon',
  },
  BCH: {
    name: 'Bitcoin Cash',
    basic: 'symbol_detail.BCH.basic',
    intro: 'symbol_detail.BCH.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/bitcoin-cash',
    cmcLink: 'https://coinmarketcap.com/currencies/bitcoin-cash',
  },
  XLM: {
    name: 'Stellar',
    basic: 'symbol_detail.XLM.basic',
    intro: 'symbol_detail.XLM.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/stellar',
    cmcLink: 'https://coinmarketcap.com/currencies/stellar',
  },
  XTZ: {
    name: 'Tezos',
    basic: 'symbol_detail.XTZ.basic',
    intro: 'symbol_detail.XTZ.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/tezos',
    cmcLink: 'https://coinmarketcap.com/currencies/tezos',
  },
  AVAX: {
    name: 'Avalanche',
    basic: 'symbol_detail.AVAX.basic',
    intro: 'symbol_detail.AVAX.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/avalanche',
    cmcLink: 'https://coinmarketcap.com/currencies/avalanche',
  },
  IOST: {
    name: 'IOST',
    basic: 'symbol_detail.IOST.basic',
    intro: 'symbol_detail.IOST.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/iost',
    cmcLink: 'https://coinmarketcap.com/currencies/iost',
  },
  MANA: {
    name: 'Decentraland',
    basic: 'symbol_detail.MANA.basic',
    intro: 'symbol_detail.MANA.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/decentraland',
    cmcLink: 'https://coinmarketcap.com/currencies/decentraland',
  },
  SAND: {
    name: 'The Sandbox',
    basic: 'symbol_detail.SAND.basic',
    intro: 'symbol_detail.SAND.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/the-sandbox',
    cmcLink: 'https://coinmarketcap.com/currencies/the-sandbox',
  },
  DAI: {
    name: 'DAI',
    basic: 'symbol_detail.DAI.basic',
    intro: 'symbol_detail.DAI.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/dai',
    cmcLink: 'https://coinmarketcap.com/currencies/dai',
  },
  BUSD: {
    name: 'Binance USD',
    basic: 'symbol_detail.BUSD.basic',
    intro: 'symbol_detail.BUSD.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/binance-usd',
    cmcLink: 'https://coinmarketcap.com/currencies/binance-usd',
  },
  USDC: {
    name: 'USD Coin',
    basic: 'symbol_detail.USDC.basic',
    intro: 'symbol_detail.USDC.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/usd-coin',
    cmcLink: 'https://coinmarketcap.com/currencies/usd-coin',
  },
  TUSD: {
    name: 'TrueUSD',
    basic: 'symbol_detail.TUSD.basic',
    intro: 'symbol_detail.TUSD.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/true-usd',
    cmcLink: 'https://coinmarketcap.com/currencies/true-usd',
  },
  ORBS: {
    name: 'ORBS',
    basic: 'symbol_detail.ORBS.basic',
    intro: 'symbol_detail.ORBS.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/orbs',
    cmcLink: 'https://coinmarketcap.com/currencies/orbs',
  },
  ATOM: {
    name: 'Cosmos',
    basic: 'symbol_detail.ATOM.basic',
    intro: 'symbol_detail.ATOM.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/cosmos-hub',
    cmcLink: 'https://coinmarketcap.com/currencies/cosmos-hub',
  },
  DOGE: {
    name: 'Dogecoin',
    basic: 'symbol_detail.DOGE.basic',
    intro: 'symbol_detail.DOGE.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/dogecoin',
    cmcLink: 'https://coinmarketcap.com/currencies/dogecoin',
  },
  SHIB: {
    name: 'Shiba Inu',
    basic: 'symbol_detail.SHIB.basic',
    intro: 'symbol_detail.SHIB.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/shiba-inu',
    cmcLink: 'https://coinmarketcap.com/currencies/shiba-inu',
  },
  // FTM: {
  //   name: 'Fantom',
  //   basic: 'symbol_detail.FTM.basic',
  //   intro: 'symbol_detail.FTM.intro',
  //   coingeckoLink: 'https://www.coingecko.com/en/coins/fantom',
  //   cmcLink: 'https://coinmarketcap.com/currencies/fantom',
  // },
  S: {
    name: 'Sonic',
    basic: 'symbol_detail.S.basic',
    intro: 'symbol_detail.S.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/sonic',
    cmcLink: 'https://coinmarketcap.com/currencies/sonic',
  },
  DOT: {
    name: 'Polkadot',
    basic: 'symbol_detail.DOT.basic',
    intro: 'symbol_detail.DOT.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/polkadot',
    cmcLink: 'https://coinmarketcap.com/currencies/polkadot',
  },
  IOTX: {
    name: 'IoTeX',
    basic: 'symbol_detail.IOTX.basic',
    intro: 'symbol_detail.IOTX.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/iotex',
    cmcLink: 'https://coinmarketcap.com/currencies/iotex',
  },
  LUNA: {
    name: 'Terra',
    basic: 'symbol_detail.LUNA.basic',
    intro: 'symbol_detail.LUNA.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/terra',
    cmcLink: 'https://coinmarketcap.com/currencies/terra-luna-v2/',
  },
  LUNC: {
    name: 'Terra Classic',
    basic: 'symbol_detail.LUNC.basic',
    intro: 'symbol_detail.LUNC.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/terra-luna',
    cmcLink: 'https://coinmarketcap.com/currencies/terra-luna',
  },
  NEAR: {
    name: 'NEAR Protocol',
    basic: 'symbol_detail.NEAR.basic',
    intro: 'symbol_detail.NEAR.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/near',
    cmcLink: 'https://coinmarketcap.com/currencies/near-protocol/',
  },
  SWEAT: {
    name: 'Sweat Economy',
    basic: 'symbol_detail.SWEAT.basic',
    intro: 'symbol_detail.SWEAT.intro',
    coingeckoLink: 'https://www.coingecko.com/en/coins/sweat-economy',
    cmcLink: 'https://coinmarketcap.com/currencies/sweat-economy/',
  },
  // XCR: {
  //   name: 'CROSS',
  //   basic: 'symbol_detail.XCR.basic',
  //   intro: 'symbol_detail.XCR.intro',
  // },
  // RIGHTS: {
  //   name: 'CROSS',
  //   basic: 'symbol_detail.RIGHTS.basic',
  //   intro: 'symbol_detail.RIGHTS.intro',
  // },
};
